import privacyPolicyContent from './content/privacy-policy.json';

const privacyPolicyMock = {
    layoutType: 2,
    data: {
        name: 'privacy-policy',
        layoutType: 2,
        areasList: [
            {
                id: 'privacy-policy-page-area',
                name: 'Content',
                componentName: 'Comp:PrivacyPolicyPage',
                content: JSON.stringify(privacyPolicyContent),
            },
        ],
    },
};

export default privacyPolicyMock;
